export default __webpack_public_path__ + "media/sach-icon-white.9c90a840.svg";